import { render } from "./DynaBadge.vue?vue&type=template&id=921fe1b2&scoped=true"
import script from "./DynaBadge.vue?vue&type=script&lang=js"
export * from "./DynaBadge.vue?vue&type=script&lang=js"

import "./DynaBadge.vue?vue&type=style&index=0&id=921fe1b2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-921fe1b2"]])

export default __exports__